/**
 * @link https://craftcms.com/
 * @copyright Copyright (c) Pixel & Tonic, Inc.
 * @license GPL-3.0-or-later
 */

import ToolbarBuilder from './ToolbarBuilder';
import ConfigOptions from './ConfigOptions';

window.CKEditor5.craftcms.ToolbarBuilder = ToolbarBuilder;
window.CKEditor5.craftcms.ConfigOptions = ConfigOptions;
